import React from 'react';
import styled from 'styled-components';
import spaces from '../../settings/spaces';

export interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
    offsetRight?: boolean;
    offsetLeft?: boolean;
}

const StyledSvgIcon = styled.svg<SvgIconProps>`
    color: ${({ color }) => color};
    margin-right: ${({ offsetRight }) => (offsetRight ? spaces.iconOffset : null)};
    margin-left: ${({ offsetLeft }) => (offsetLeft ? spaces.iconOffset : null)};
`;

export function SvgIcon({
    ref, // ref type is incompatible, so pull it off and ignore it as we don't need it (yet)
    children,
    viewBox = '0 0 32 32',
    width = '1em',
    height = '1em',
    fontSize = 'inherit',
    offsetRight = false,
    offsetLeft = false,
    ...rest
}: SvgIconProps) {
    return (
        <StyledSvgIcon
            viewBox={viewBox}
            width={width}
            height={height}
            fontSize={fontSize}
            offsetLeft={offsetLeft}
            offsetRight={offsetRight}
            {...rest}
        >
            {children}
        </StyledSvgIcon>
    );
}
